<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.country') }}
        </label>
        <div class="filter__item__body">
          <!-- TODO :: Вынести в отдельный компонент -->
          <i-select
            v-model="form.country"
            :loading="is_loading"
            :transfer="true"
            :filterable="true"
            @on-change="submitOnDelay"
          >
            <i-option v-for="c in country" :key="c.id" :value="c.iso" :label="c.label" />
          </i-select>
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.type') }}
        </label>
        <div class="filter__item__body">
          <i-select
            v-model="form.type"
            :transfer="true"
            :filterable="true"
            :clearable="true"
            :disabled="is_disabled_types"
            @on-change="submitOnDelay"
          >
            <i-option v-for="(title, key) in types" :key="key" :value="key" :label="title" />
          </i-select>
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.region') }}
        </label>
        <div class="filter__item__body">
          <i-select
            v-model="form.region"
            :transfer="true"
            :filterable="true"
            :clearable="true"
            :disabled="is_disabled_regions"
            @on-change="submitOnDelay"
          >
            <i-option v-for="title in regions" :key="title" :value="title" :label="title" />
          </i-select>
        </div>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import pickBy from 'lodash-es/pickBy';

  import { mapActions } from 'vuex';
  import { CountryService as CountryNumbersService } from '@phone-number/services/CountryService';
  import { CountryService } from '@core/services/CountryService';
  import CountrySelect from '@shared/components/input/input-country-select';
  import axios from 'axios';
  import faker from 'faker/locale/en';

  export default {
    components: {
      FilterWrapper,
      CountrySelect
    },
    data: () => ({
      types: {},
      regions: [],

      is_loading_types: false,
      is_loading_regions: false,

      is_loading: false,
      country: [],

      form: {
        country: [],
        type: null,
        region: null
      }
    }),
    computed: {

      is_disabled_types: function () {
        return !this.form.country.length || this.isLoading || this.is_loading_types;
      },

      is_disabled_regions: function () {
        return this.is_disisLoadingabled_types || !this.form.type || this.is_loading_regions;
      },

      is_button_loading: function () {
        return this.isLoading || this.is_loading_types || this.is_loading_regions;
      }
    },

    watch: {
      ['form.country']: function (country_iso_code) {
        const i18n_types = this.$t('phone-number.number.type');
        const default_type = 'local';
        this.is_loading_types = true;

        this.get_types_by_country(country_iso_code)
          .then((res) => {
            const type_from_api = Array.isArray(res) ? res : [];
            const is_exist = (key) => type_from_api.includes(key);

            this.types = pickBy(i18n_types, (val, key) => is_exist(key));
            this.regions = [];

            const type_keys = Object.keys(this.types);

            if (type_keys.includes(default_type)) {
              this.form.type = default_type;
            } else if (type_keys.length) {
              this.form.type = type_keys[0];
            } else {
              this.form.type = null;
            }
          })
          .finally(() => (this.is_loading_types = false));
      },
    },

    mounted() {
      this.is_loading = true;
      axios
        .all([CountryService.getSelect(), CountryService.getCountriesCodes()])
        .then(
          axios.spread((isoCodes, codes) => {
            this.country = this.mergeCodesAndIso(codes, isoCodes);
          })
        )
        .finally(() => (this.is_loading = false));

      this.$watch(
        (vm) => ({ country: vm.form.country, type: vm.form.type }),
        function (now, old) {
          const { country: new_country, type: new_type } = now;
          const { country: old_country, type: old_type } = old;

          if (new_type) {
            if (old_country !== new_country || new_type !== old_type) {
              this.is_loading_regions = true;

              CountryNumbersService.getRegions(new_country, new_type)
                .then((res) => {
                  this.regions = res;
                  this.form.region = null;
                })
                .finally(() => (this.is_loading_regions = false));
            }
          } else {
            this.regions = [];
          }
        }
      );
    },

    methods: {
      ...mapActions('phone-number/numbers/buy', ['search']),

      mergeCodesAndIso: function (codes, isoCodes) {
        const result = [];
        for (let i = 0; i < isoCodes.length; i++) {
          const language = isoCodes[i];
          const codeList = codes.filter((code) => code.country === language.country);
          const codeLabels = codeList.map((code) => `+${code.code}`);
          const label = `${language.country} ${codeLabels.join(', ')}`;
          result.push({ id: faker.random.uuid(), iso: language.iso, label });
        }
        return result;
      },

      get_types_by_country: function (country_iso_code) {
        return new Promise((resolve) => {
          if (country_iso_code) {
            return CountryNumbersService
              .getTypesByCountry(country_iso_code)
              .then((res) => resolve(res))
              .catch(() => resolve([]));
          } else {
            return resolve([]);
          }
        });
      },

      submit: function () {
        let isTypeStepEmpty = !this.form.type && this.types && this.form.country.length > 0;
        if (!isTypeStepEmpty) {
          this.search(this.form);
        }
      },

      submitOnDelay: function () {
        const submitTimer = setInterval(() => {
          if (!this.is_button_loading) {
            this.submit();
            clearInterval(submitTimer);
          }
        }, 50);
      }
    }
  };
</script>
